import { SVGProps } from 'react';

const SvgChevronUp = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M17.207 15.707a1 1 0 0 1-1.414 0L12 11.914l-3.793 3.793a1 1 0 0 1-1.414-1.414l4.5-4.5a1 1 0 0 1 1.414 0l4.5 4.5a1 1 0 0 1 0 1.414Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgChevronUp;
